<script setup lang="ts">
const emit = defineEmits<{
  success: []
  otpRequired: [email: string]
  passkeyRequired: []
}>()

const store = useAuthStore()
const toast = useToast()
const { rememberedEmail, rememberMe, saveEmail } = useRememberEmail()

const email = ref('')
const password = ref('')
const loading = ref(false)

// Initialiser l'email côté client uniquement (évite le décalage SSR/hydration)
onMounted(() => {
  if (rememberedEmail.value) {
    email.value = rememberedEmail.value
  }
})

async function handleSubmit() {
  const trimmedEmail = email.value.trim()
  if (!trimmedEmail || !password.value) return
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
    toast.add({ title: 'Email invalide', color: 'error' })
    return
  }

  loading.value = true
  try {
    saveEmail(trimmedEmail)
    const step = await store.login(trimmedEmail, password.value)
    if (step.otpRequired) {
      emit('otpRequired', trimmedEmail)
    }
    else if (step.passkeyRequired) {
      emit('passkeyRequired')
    }
    else {
      emit('success')
    }
  }
  catch (err) {
    const message = (err as { data?: { message?: string } }).data?.message
    toast.add({
      title: 'Erreur de connexion',
      description: message || 'Email ou mot de passe incorrect',
      color: 'error',
    })
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <form class="space-y-4" @submit.prevent="handleSubmit">
    <UFormField label="Email" class="w-full">
      <UInput
        v-model="email"
        type="email"
        placeholder="votre@email.com"
        icon="i-lucide-mail"
        size="lg"
        class="w-full"
        autofocus
        required
      />
    </UFormField>

    <UFormField label="Mot de passe" class="w-full">
      <UInput
        v-model="password"
        type="password"
        placeholder="Votre mot de passe"
        icon="i-lucide-lock"
        size="lg"
        class="w-full"
        required
      />
    </UFormField>

    <label class="flex items-center gap-2 cursor-pointer">
      <UCheckbox v-model="rememberMe" />
      <span class="text-sm text-[var(--ui-text-muted)]">Se souvenir de mon email</span>
    </label>

    <UButton
      type="submit"
      block
      size="lg"
      color="secondary"
      :loading="loading"
      :disabled="!email || !password"
    >
      Se connecter
    </UButton>
  </form>
</template>
